$(function () {

  var $dropdown = $('.navigation-cards__links-container');
  var anchorLinks = $('a[href*="#"]').not('[href="#"]').not('[href="#0"]');

  $dropdown.click(function (e) {
    if (window.innerWidth <= 1000) {
      $dropdown.toggleClass("open");
    }
  });

  $dropdown.find('.active').click(function (e) {
    if (window.innerWidth <= 1000) {
      e.preventDefault();
    }
  });

  $(document).click(function (event) {
    if (window.innerWidth <= 1000 && $dropdown !== event.target && !$dropdown.has(event.target).length) {
      $dropdown.removeClass("open");
    }
  });

  anchorLinks.each(function () {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        $('a[href*="#"]').parent().removeClass("active")
      }
    });

  anchorLinks.click(function (event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {

        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: (target.offset().top - 69)
          }, 1000, function () {
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              return false;
            } else {
              $target.attr('tabindex', '-1');
              $target.focus();
            };
          });
        }
        // Contacts page navigation cards
        else if (Number.isInteger(parseInt(this.hash.slice(1)))) {
          event.preventDefault();
          const hashevent = new CustomEvent('navigation-cards-hash-change', { detail: parseInt(this.hash.slice(1)) });
          window.dispatchEvent(hashevent);
        }
      }
    });
  
});